import { ContainerModule } from 'inversify';
import { configModule } from '@drs/config/DI/configModule';
import { domainModule } from '@framework/config/DI/domainModule';
import { i18nModule } from './modules/i18nModule';
import { messageManagerModule } from './modules/messageManagerModule';
import { analyticsModule } from './modules/analyticsModule';
import { DispatcherModule as UsersDispatcherModule } from '@users/json-rpc-dispatcher';
import { DispatcherModule as DataroomDispatcherModule } from '@dataroom/json-rpc-dispatcher';
import { DispatcherModule as DmPortalDispatcherModule } from '@dm-portal/json-rpc-dispatcher';
import { DmPortalDmPortalDispatcherModule } from '@dm-portal/dm-portal-json-rpc-dispatcher';
import { FileUploadModule as DmPortalFileUploadModule } from '@dm-portal/file-upload';
import { FileDownloadLinkGeneratorModule as DmPortalFileDownloadModule } from '@dm-portal/file-download-link-generator';
import { SocketModule } from '@drs/socket-client';
import { FileUploadModule } from '@drs/file-upload';
import { DispatcherModule as EvercallDispatcherModule } from '@evercall/json-rpc-dispatcher';
import { DispatcherModule as CondorDispatcherModule } from '@condor/json-rpc-dispatcher';
import { InvestorTargetingDispatcherModule } from '@drs/investor-targeting-json-rpc-dispatcher';
import { OrderBookDispatcherModule } from '@orderbook/json-rpc-dispatcher';
import { AllocateDispatcherModule } from '@allocate/json-rpc-dispatcher';
import { FileUploadModule as AllocateFileUploadModule } from '@allocate/file-upload';
import { SocketModule as AllocateSocketModule } from '@allocate/socket-client';

export const rootModules: ContainerModule[] = [
  domainModule,
  configModule,
  i18nModule,
  messageManagerModule,
  analyticsModule,
  UsersDispatcherModule,
  DataroomDispatcherModule,
  DmPortalDispatcherModule,
  DmPortalDmPortalDispatcherModule,
  DmPortalFileUploadModule,
  DmPortalFileDownloadModule,
  SocketModule,
  FileUploadModule,
  EvercallDispatcherModule,
  CondorDispatcherModule,
  InvestorTargetingDispatcherModule,
  OrderBookDispatcherModule,
  AllocateDispatcherModule,
  AllocateFileUploadModule,
  AllocateSocketModule,
];

export const serverContainerModules = [
  ...rootModules,
];
